import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import LeadForm from "./LeadForm";
import { useLang } from "@/i18n/LangContext";

export default function ConsultPopup() {
  const [open, setOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const { tr } = useLang();

  useEffect(() => {
    if (sessionStorage.getItem("cora_popup")) return;
    const t = setTimeout(() => { setOpen(true); sessionStorage.setItem("cora_popup", "1"); }, 6000);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {open && (
        <motion.div className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setOpen(false)} data-testid="consult-popup">
          <motion.div initial={{ y: 60, scale: 0.92, opacity: 0 }} animate={{ y: 0, scale: 1, opacity: 1 }} exit={{ y: 40, opacity: 0 }} transition={{ type: "spring", damping: 22 }} className="relative w-full max-w-md bg-[#131B21] border border-[#00C9B7]/25 rounded-3xl overflow-hidden max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setOpen(false)} className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-black/60 flex items-center justify-center text-white" aria-label="Close" data-testid="consult-popup-close-btn"><X size={18} /></button>
            {!showForm && <img src="/img/appointment.jpg" alt="Dentist appointment calendar" className="w-full h-44 object-cover" />}
            <div className="p-7 text-center">
              <h3 className="font-display text-3xl text-[#00C9B7] mb-2">{tr("Schedule a free consultation!", "¡Agenda una consulta gratis!")}</h3>
              <p className="text-slate-300 mb-6 text-sm">{tr("Managua & San Juan Del Sur Locations*", "Sedes en Managua y San Juan del Sur*")}</p>
              {showForm ? (
                <div className="text-left"><LeadForm source="free-consultation" idPrefix="popup" compact /></div>
              ) : (
                <button onClick={() => setShowForm(true)} className="rounded-full bg-[#00C9B7] text-[#031312] px-8 py-3.5 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#00E0CC] transition-colors" data-testid="consult-popup-cta-btn">{tr("Free Consultation", "Consulta Gratis")}</button>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
